import Api from '@/services/Api'

export default {
  /**
   * Fire Login Request.
   * @param {Object} payload {user: "", password: ""}
   */
  login (payload) {
    return Api().post('auth/login', payload)
  },
  checkPassword (password) {
    return Api().post('auth/check', { password: password})
  }
}